module.exports = __webpack_public_path__ + "img/Minchul.12005171.png";